import type { GroupedPurposesBySection } from "@ui/components/ConsentSection";

import type { OtPurpose, OtPurposeByUUID } from "@jti/fe-common";

export const groupPurposesBySection = (purposes: (OtPurpose | OtPurposeByUUID)[]): GroupedPurposesBySection[] => {
  return purposes.reduce((acc: GroupedPurposesBySection[], currentPurpose) => {
    const sectionPurpose = acc.find((purpose) => purpose.purposeId === currentPurpose.section.id);
    const preparedPurposeData = {
      ...currentPurpose,
      purposeName: currentPurpose.name,
      purposeDescription: currentPurpose.description,
    };

    if (sectionPurpose) {
      sectionPurpose.purposes.push(preparedPurposeData);
    } else {
      acc.push({
        purposeTitle: currentPurpose.section.name,
        purposeDescription: currentPurpose.section.description,
        purposeId: currentPurpose.section.id,
        purposes: [preparedPurposeData],
      });
    }
    return acc;
  }, []);
};
